<footer>
  {{version()}}
</footer>
